export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const getStatusIcon = (status, uploadProgress) => {
  switch (status) {
    case 'completed':
      return { color: '#10B981', fontSize: 20 };
    case 'uploading':
      return { width: 16, height: 16, borderRadius: 8 };
    case 'error':
      return { color: '#EF4444', fontSize: 20 };
    default:
      return { color: '#6B7280', fontSize: 20 };
  }
};
